import { render, staticRenderFns } from "./TransferOwnershipDialogue.vue?vue&type=template&id=b4a4d722"
import script from "./TransferOwnershipDialogue.vue?vue&type=script&setup=true&lang=ts"
export * from "./TransferOwnershipDialogue.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TransferOwnershipDialogue.vue?vue&type=style&index=0&id=b4a4d722&prod&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports